import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle `

    html, body, div, span, applet, object, iframe,
    h1, h2, h3, h4, h5, h6, p, blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, strong, sub, sup, tt, var,
    b, u, i, center,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, embed, 
    figure, figcaption, footer, header, hgroup, 
    menu, nav, output, ruby, section, summary,
    time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
    }
    
    article, aside, details, figcaption, figure, 
    footer, header, hgroup, menu, nav, section {
        display: block;
    }
    body {
        line-height: 1;
    }
    ol, ul {
        list-style: none;
    }
    blockquote, q {
        quotes: none;
    }
    blockquote:before, blockquote:after,
    q:before, q:after {
        content: '';
        content: none;
    }
    table {
        border-collapse: collapse;
        border-spacing: 0;
    }


    @font-face {
        font-family: 'CircularStd';
        src: url('fonts/CircularStd-Book.ttf') format('truetype');
    }

    body {
        width: 100%;
        height: 100vh;
        background-image: url('/assets/background-mask.png');
        background-position: right top;
        background-size: contain;
        background-repeat: no-repeat;
        overflow-x: hidden;
    }

    * {
        font-family: ${props => props.theme.fonts.fontStyle1};
        box-sizing: border-box;
    }
    
    @media (max-width: 900px) { 
        body {
            background-color: #FAFAFA;
            background-image: none;
        }
    }
`